export default __webpack_public_path__ + "static/media/all-contact-icon.9b0c33ce.png";